import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Formik,
  Form,
  ErrorMessage,
  FieldArray,
  useFormik,
  setIn,
} from "formik";
import { Dropdown } from "primereact/dropdown";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { IoAddCircleOutline } from "react-icons/io5";
import { MultiSelect } from "primereact/multiselect";
import YtVideoCard from "./YtVideoCard";
import { compressImage } from "../../../App/Helpers/compressImage";
import Tooltip from "../../../Components/Tooltip/Tooltip";
import ToggleField from "../../../Components/ToggleField";
import { FormField } from "../../../Components/FormField";
import LoaderContext from "../../../Components/loader";
import SidebarField from "../../../Components/SidebarField";
import TextInput from "../../../Components/TextInput";
import ImagePreview from "../../../Components/ImagePreview";
import Button from "../../../Components/Button";
import { BreadCrumb } from "primereact/breadcrumb";
import { FaSearch } from "react-icons/fa";
import YouTubeUploader from "./YouTubeUploader";
import { useFetchAll } from "../../../custom/FetchApiHook";
import { ResourceApi } from "../../../App/api/Resources.apis";
import ResourceCard from "./ResourceCard";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import { toast } from "react-toastify";
import DeleteFieldModal from "../../../Components/Common/DeleteFieldModal";
import { toFormData } from "axios";
import YoutubeApi from "./server";
import LoginYT from "./LoginYT";
import ReactQuill from "react-quill";

const Resources = () => {
  const [isVisible, setVisible] = useState(false);
  const [isUploadVisible, setUploadVisible] = useState(false);
  const [currentItems, setCurrentItems] = useState("");
  const debounceTimeout = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteModal, setDeleteModal] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const { handleLoading } = useContext(LoaderContext);
  const [croppedImageURL, setCroppedImageURL] = useState(null);
  const [resourcesData, setResourcesData] = useState([]);
  const [error, setError] = useState("");
  const [statusPublic, setStatusPublic] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);
  const [index, setIndex] = useState();
  const [isUpdate, setIsUpdate] = useState({
    introVideo: false,
    courseVideo: false,
  });
  const [videoIds, setVideoIds] = useState({
    introVideoId: null,
    courseVideoId: null,
  });

  useEffect(() => {
    function getYouTubeVideoID(url) {
      const regex =
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|shorts)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      const match = url?.match(regex);
      return match ? match[1] : null;
    }

    const introVideoID =
      currentItems && getYouTubeVideoID(currentItems?.introVideoLink);
    const courseVideoID =
      currentItems &&
      getYouTubeVideoID(currentItems?.syllabusDetails?.syllabus?.[0]?.video);

    setVideoIds((prev) => {
      return {
        introVideoId: introVideoID,
        courseVideoId: courseVideoID,
      };
    });
  }, [currentItems]);

  const formikRef = useRef();
  const [ytUrl, setYturl] = useState({
    intro: "",
    syllabus: [],
  });

  console.log(ytUrl);

  const [copied, setCopied] = useState(false);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleCroppedImage = (croppedBlob) => {
    // Convert blob to a URL for preview or upload
    const previewURL = URL.createObjectURL(croppedBlob);
    setCroppedImageURL(previewURL);
  };
  // const {value, fetchAllData } = useFetchAll(() =>ResourceApi.getAllResource());

  const getAllResources = async () => {
    try {
      const res = await ResourceApi.getAllResource();
      setResourcesData(res.data.data.courses);
    } catch (error) {
      console.error("Error fetching resources:", error);
    }
  };

  useEffect(() => {
    getAllResources();
  }, []);

  const handleFileUpload = (e, setFieldValue) => {
    const file = e.target.files[0];

    if (file) {
      // Check if file size exceeds 1MB
      const fileSizeInMB = file.size / 1024 / 1024;
      if (fileSizeInMB > 1) {
        setError("Please select an image smaller than 1MB.");
        setFieldValue("image", null);
        return;
      }

      // Clear error and set the file if size is valid
      setError("");
      setFieldValue("image", file);
    }
  };

  // This function removes the video from youtube and update the resource also
  const handleDeleteYTVideo = async (type, values, setFieldValue, index) => {
    handleLoading(true);

    const videoId =
      type === "intro" ? videoIds.introVideoId : videoIds.courseVideoId;

    const payload = { videoId };

    try {
      const res = videoId && (await YoutubeApi.ytDeleteVideo(payload));

      if (type === "intro") {
        setCurrentItems((prev) => ({
          ...prev,
          introVideoLink: null,
        }));
        setFieldValue("introVideoLink", "", false);
      } else {
        const updatedSyllabus = values.syllabusDetails.syllabus.map(
          (item, idx) => (idx === index ? { ...item, video: "" } : item)
        );

        setCurrentItems((prev) => ({
          ...prev,
          syllabusDetails: {
            ...prev.syllabusDetails,
            syllabus: updatedSyllabus,
          },
        }));

        setFieldValue(`syllabusDetails.syllabus[${index}].video`, "", "");
      }

      const updatedValues = {
        ...values,
        introVideoLink: type === "intro" ? "" : values.introVideoLink,
        syllabusDetails:
          type === "course"
            ? {
                ...values.syllabusDetails,
                syllabus: values.syllabusDetails.syllabus.map((item, idx) =>
                  idx === index ? { ...item, video: "" } : item
                ),
              }
            : values.syllabusDetails,
      };

      // console.log("Updated values", updatedValues);
      const formData = toFormData(updatedValues);

      const updateResource = await ResourceApi.updateResource(
        formData,
        currentItems._id
      );

      console.log("API Response:", res.data);
      getAllResources();
    } catch (err) {
      console.error("Error deleting video via API:", err);
      setIsLoggedIn(false);
      setLoginError(true);
    } finally {
      handleLoading(false);
    }
  };

  const handleDeleteModel = (id) => {
    setDeleteModal(true);
    setDeleteId(id);
  };

  const handleDeleteClose = () => {
    setDeleteModal(false);
  };

  const handleDelete = async () => {
    try {
      if (deleteId !== null) {
        const res = await ResourceApi.deleteResource(deleteId);
        toast.success(`${res.data.message}`);
        getAllResources();
      }
    } catch (err) {
      // console.log(err);
    } finally {
      handleDeleteClose();
    }
  };

  const createFormData = (payload) => {
    const formData = new FormData();

    // Append basic fields
    formData.append("title", payload.title);
    formData.append("author", payload.author);
    formData.append("contentType", payload.contentType);
    formData.append("cashCropCategory", payload.cashCropCategory);
    formData.append("overview", payload.overview);
    formData.append("image", payload.image); // Ensure 'image' is a file if needed
    formData.append("language", payload.language);
    formData.append("datePublished", payload.datePublished);
    formData.append("introVideoLink", payload.introVideoLink);
    formData.append("expertContact", payload.expertContact);
    formData.append("courseDetails", payload.courseDetails);
    formData.append("courseLevel", payload.courseLevel);

    // Handle array fields
    payload.targetAudience.forEach((item, index) => {
      formData.append(`targetAudience[${index}]`, item);
    });

    payload.keywords.forEach((keyword, index) => {
      formData.append(`keywords[${index}]`, keyword);
    });

    // Handle nested syllabusDetails
    formData.append(
      "syllabusDetails.courseDuration",
      payload.syllabusDetails.courseDuration
    );

    payload.syllabusDetails.syllabus.forEach((syllabusItem, index) => {
      formData.append(
        `syllabusDetails.syllabus[${index}].title`,
        syllabusItem.title
      );
      formData.append(
        `syllabusDetails.syllabus[${index}].duration`,
        syllabusItem.duration
      );
      formData.append(
        `syllabusDetails.syllabus[${index}].video`,
        syllabusItem.video
      );

      // Handle downloadableMaterials (assuming it's an object)
      Object.keys(syllabusItem.downloadableMaterials).forEach((key) => {
        formData.append(
          `syllabusDetails.syllabus[${index}].downloadableMaterials[${key}]`,
          syllabusItem.downloadableMaterials[key]
        );
      });
    });

    formData.append(
      "syllabusDetails.certification",
      payload.syllabusDetails.certification
    );
    console.log("FormData Entries:", [...formData.entries()]);

    return formData;
  };

  const handleSubmit = async (values, { resetForm }) => {
    toFormData(values);
    handleLoading(true);

    const formData = toFormData(values);
    try {
      console.log("FormData Entries:", [...formData.entries()]);

      const res = currentItems?._id
        ? await ResourceApi.updateResource(formData, currentItems._id)
        : await ResourceApi.createResource(formData);

      if (res.data.success) {
        console.log("Resource saved successfully:", res.data.data);
        toast.success("Saved successfully");
        getAllResources();
      } else {
        console.log("Error saving resource:", res.data.message);
      }
    } catch (error) {
      console.error(
        "Error submitting form:",
        error.response?.data || error.message
      );
    } finally {
      handleLoading(false);
      resetForm();
      handleClose();
      setYturl({
        intro: "",
        syllabus: [],
      });
    }
  };

  const initialValues = {
    title: currentItems?.title || "",
    author: currentItems?.author || "",
    contentType: currentItems?.contentType || "",
    cashCropCategory: currentItems?.cashCropCategory || "",
    overview: currentItems?.overview || "",
    image: currentItems?.image || "",
    targetAudience: currentItems?.targetAudience || [],
    language: currentItems?.language || "",
    keywords: currentItems?.keywords || [],
    datePublished: currentItems?.datePublished || "",
    introVideoLink: currentItems?.introVideoLink || "",
    expertContact: currentItems?.expertContact || "",
    courseDetails: currentItems?.courseDetails || "",
    courseLevel: currentItems?.courseLevel || "",
    // coursePrice:"",
    syllabusDetails: {
      courseDuration: currentItems?.syllabusDetails?.courseDuration || "",
      syllabus: currentItems?.syllabusDetails?.syllabus || [
        { title: "", duration: "", video: "", downloadableMaterials: {} },
      ],
      certification: currentItems?.courseDetails?.certification || false,
    },
  };

  const handleSearch = useCallback((s) => {
    setSearchQuery(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s.target.value);
      }, 1500);
    },
    [handleSearch]
  );
  const handleOpen = (item) => {
    setCurrentItems();
    if (item) {
      setCurrentItems(item);
      //   setPreview(item?.image);
    }
    // setVisible(true);
  };
  const onCourceCardClick = (resource) => {
    setVisible(true);
    setCurrentItems(resource);
  };

  const handleClose = () => {
    // setFile(null);
    // setPreview(null);
    setVisible(false);
    setCurrentItems();
    // setSubCategoryFields([]);
  };

  return (
    <>
      {!isLoggedIn && (
        <LoginYT setIsLoggedIn={setIsLoggedIn} loginError={loginError} />
      )}
      {isLoggedIn && (
        <div className="p-5 w-[100%] ">
          <CommonLayout />
          <div className="flex justify-between mx-5 border-b pb-2">
            <div className="border border-[--color--1] rounded-full px-3 py-1.5 text-xs bg-transparent w-fit flex justify-between items-center">
              <input
                type="search"
                placeholder="search..."
                // value={searchQuery}
                onChange={debouncedSearch}
                className="bg-transparent outline-none"
              />
              <FaSearch className="text-[--color--1]" />
            </div>
            <Button
              text="Add New"
              type="button"
              className="float-end"
              onClick={() => {
                setVisible(true);
                setCurrentItems();
              }}
            />
          </div>
          <div className="grid grid-cols-1 gap-3 mb-20 lg:grid-cols-3  ">
            {/* <YtVideoCard/> */}
            {resourcesData.length > 0 &&
              resourcesData.map((resource, i) => {
                return (
                  <ResourceCard
                    resource={resource}
                    onEdit={() => onCourceCardClick(resource)}
                    getAllResources={getAllResources}
                    handleDeleteModel={handleDeleteModel}
                  />
                );
              })}
          </div>

          {isVisible && (
            <Formik
              initialValues={initialValues}
              // validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({ values, handleChange, setFieldValue }) => (
                <Form className="w-full flex gap-0  flex-col bg-transparent py-5 px-3">
                  <SidebarField
                    handleClose={handleClose}
                    title={
                      currentItems?._id ? "Update Resource" : "Add New Resource"
                    }
                    button1={
                      <Button
                        text="Cancel"
                        type="button"
                        onClick={handleClose}
                      />
                    }
                    button2={
                      <Button text={currentItems?._id ? "Update" : "Add"} />
                    }
                  >
                    {/* Title */}
                    <FormField label="Title" tooltip="Enter the resource title">
                      <TextInput
                        name="title"
                        type="text"
                        placeholder="Enter resource title"
                        value={values.title}
                        onChange={handleChange}
                        className={"mb-2"}
                      />
                      <ErrorMessage
                        name="title"
                        component="div"
                        className="error"
                      />
                    </FormField>

                    {/* Author */}
                    <FormField label="Author" tooltip="Enter the author's name">
                      <TextInput
                        name="author"
                        type="text"
                        placeholder="Enter author name"
                        value={values.author}
                        onChange={handleChange}
                        className={"mb-1"}
                      />
                      <ErrorMessage
                        name="author"
                        component="div"
                        className="error"
                      />
                    </FormField>

                    {/* Content Type */}
                    <FormField
                      label="Content Type"
                      tooltip="Select type of content"
                    >
                      <div id="contentType" className="mb-2">
                        <Dropdown
                          options={[
                            { label: "Article", value: "article" },
                            { label: "Guide", value: "guide" },
                            { label: "Manual", value: "manual" },
                            {
                              label: "Training Material",
                              value: "training_material",
                            },
                            { label: "Case Study", value: "case_study" },
                            {
                              label: "Best Practices",
                              value: "best_practices",
                            },
                            { label: "Webinar/Workshop", value: "webinar" },
                            { label: "Expert Advice", value: "expert_advice" },
                          ]}
                          name="contentType"
                          value={values?.contentType}
                          className={"mb-4 w-full border h-10"}
                          onChange={handleChange}
                          handleOnchange={(v) => {
                            console.log("Selected Content Type:", v);
                          }}
                        />
                        <ErrorMessage
                          name="contentType"
                          component="div"
                          className="error"
                        />
                      </div>
                    </FormField>

                    {/* Cash Crop Category */}
                    <FormField
                      label="Cash Crop Category"
                      tooltip="Select related cash crop category"
                    >
                      <div id="cashCropCategory" className="mb-4">
                        <Dropdown
                          options={[
                            { label: "Cocoa", value: "cocoa" },
                            { label: "Cashew", value: "cashew" },
                            { label: "Advanced", value: "oil_palm" },
                            { label: "Shea", value: "shea" },
                            { label: "Coffee", value: "coffee" },
                            { label: "Rubber", value: "rubber" },
                            { label: "Other", value: "other" },
                          ]}
                          name="cashCropCategory"
                          value={values?.cashCropCategory}
                          className={"mb-4 w-full border h-10"}
                          onChange={handleChange}
                          handleOnchange={(v) => {
                            console.log("Selected Cash Crop Category:", v);
                          }}
                        />
                        <ErrorMessage
                          name="cashCropCategory"
                          component="div"
                          className="error"
                        />
                      </div>
                    </FormField>

                    {/* Overview */}
                    <FormField label="Overview" tooltip="Enter a brief summary">
                      <div id="overview">
                        <ReactQuill
                          theme="snow"
                          value={values.overview}
                          onChange={(v) => setFieldValue("overview", v)}
                        />
                        <ErrorMessage
                          name="overview"
                          component="div"
                          className="error"
                        />
                      </div>
                      {/* <TextInput
                    name="overview"
                    type="text"
                    placeholder="Enter brief summary"
                    value={values.overview}
                    className={"mb-4"}
                    onChange={handleChange}
                  />
                  <ErrorMessage
                    name="overview"
                    component="div"
                    className="error"
                  /> */}
                    </FormField>

                    {/* course details*/}
                    <div className="mt-2">
                      <FormField
                        label="Course Details"
                        tooltip="Enter Course Details"
                      >
                        <TextInput
                          name="courseDetails"
                          type="textarea"
                          placeholder="Enter Course Details"
                          value={values.courseDetails}
                          className={"mb-4"}
                          onChange={handleChange}
                        />
                        <ErrorMessage
                          name="courseDetails"
                          component="div"
                          className="error"
                        />
                      </FormField>
                    </div>

                    {/* Target Audience */}
                    <div className="mt-2">
                      <FormField
                        label="Target Audience"
                        tooltip="Select the intended audience"
                      >
                        <div id="targetAudience" className="mb-4 w-full">
                          <MultiSelect
                            value={values.targetAudience}
                            filter
                            onChange={(e) => {
                              console.log(e);
                              setFieldValue("targetAudience", e.target.value);
                            }}
                            options={[
                              {
                                label: "Beginner Farmers",
                                value: "beginner_farmers",
                              },
                              {
                                label: "Experienced Farmers",
                                value: "experienced_farmers",
                              },
                              {
                                label: "Agro-entrepreneurs",
                                value: "agro_entrepreneurs",
                              },
                              {
                                label: "Agricultural Researchers",
                                value: "agricultural_researchers",
                              },
                              { label: "Policymakers", value: "policymakers" },
                            ]}
                            optionLabel="label"
                            optionValue="value"
                            style={{ width: "100%" }}
                            className="md:w-20rem"
                            placeholder="Select options"
                          />

                          <ErrorMessage
                            name="targetAudience"
                            component="div"
                            className="error"
                          />
                        </div>
                      </FormField>
                    </div>

                    {/* Language */}
                    <div className="mt-2">
                      <FormField label="Language" tooltip="Select language">
                        <div id="language" className="mb-4">
                          <Dropdown
                            options={[
                              { label: "English", value: "english" },
                              { label: "TWI", value: "twi" },
                              { label: "GA", value: "ga" },
                              { label: "EWE", value: "ewe" },
                            ]}
                            name="language"
                            className={"mb-4 w-full border h-10"}
                            value={values?.language}
                            onChange={handleChange}
                            handleOnchange={(v) => {
                              console.log("Selected Language:", v);
                            }}
                          />
                          <ErrorMessage
                            name="language"
                            component="div"
                            className="error"
                          />
                        </div>
                      </FormField>
                    </div>

                    {/* keywords */}
                    <div className="mt-2">
                      <FormField
                        label="Keywords"
                        tooltip="Enter keywords separated by commas"
                      >
                        <TextInput
                          name="keywords"
                          type="text"
                          placeholder="Enter keywords"
                          value={values.keywords.join(", ")}
                          className={"mb-4"}
                          onChange={(e) => {
                            const input = e.target.value;
                            setFieldValue(
                              "keywords",
                              input.split(",").map((keyword) => keyword.trim())
                            );
                          }}
                        />
                        <ErrorMessage
                          name="keywords"
                          component="div"
                          className="error"
                        />
                      </FormField>
                    </div>

                    {/* thumbnail image input  */}
                    <div className="flex items-center mt-2">
                      <label className="block text-sm font-medium text-gray-700">
                        Thumbnail
                      </label>
                      <Tooltip text="Add a thumbnail for your course" />
                    </div>
                    <div className="flex flex-col items-center mb-6 justify-center w-full space-y-4">
                      <label
                        htmlFor="image-upload"
                        className="w-full flex items-center justify-center cursor-pointer border border-dashed border-gray-300 rounded-lg py-4 px-6 hover:bg-gray-100 transition duration-150 ease-in-out"
                      >
                        <TextInput
                          name="image"
                          type="file"
                          placeholder="Choose File"
                          id="image-upload"
                          onChange={(e) => handleFileUpload(e, setFieldValue)}
                          className="hidden"
                        />
                        <span className="text-gray-500 text-sm">
                          Click to upload an image
                        </span>
                      </label>
                      <ErrorMessage
                        name="image"
                        component="div"
                        className="text-red-500 text-xs mt-1"
                      />

                      {values.image && (
                        <div className="relative w-full flex items-center justify-center">
                          {typeof values.image !== "object" &&
                          currentItems?._id ? (
                            <LazyLoadImage
                              src={values.image}
                              alt="Uploaded"
                              loading="lazy"
                              effect="blur"
                              className="w-full h-auto rounded-xl shadow-md"
                              style={{
                                objectFit: "contain",
                                maxHeight: "300px",
                              }}
                            />
                          ) : (
                            <ImagePreview
                              file={values.image}
                              id="image"
                              className="w-full h-auto rounded-xl shadow-md"
                            />
                          )}
                          <button
                            type="button"
                            onClick={() => {
                              setFieldValue("image", "");
                            }}
                            className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded-full text-xs hover:bg-red-600 shadow-md"
                          >
                            Remove
                          </button>
                        </div>
                      )}
                    </div>

                    {/* video links (Intro video) */}
                    <div className="mb-4">
                      <div className="flex items-center">
                        <label className="block text-sm">Intro Video</label>
                        <Tooltip text="After uploading a video, copy the provided link and paste it into the input box." />
                      </div>
                      <TextInput
                        name="introVideoLink"
                        type="text"
                        placeholder="Enter the below link"
                        readOnly={ytUrl.intro ? false : true}
                        value={values.introVideoLink}
                        // value={ytUrl.intro && ytUrl.intro}
                        onChange={handleChange}
                        required={true}
                        // onChange={(e) =>
                        //   setFieldValue("introVideoLink", ytUrl.intro)
                        // }
                        className="mb-2"
                        multiline
                      />
                      {ytUrl && ytUrl.intro && (
                        <div className="relative group">
                          <div
                            onClick={() => handleCopy(ytUrl.intro)}
                            className="cursor-pointer w-40 text-blue-500 underline mb-2 hover:text-blue-600 transition duration-200"
                          >
                            {ytUrl.intro}
                          </div>

                          {copied && (
                            <div className="absolute top-0 left-10 ml-2 px-2 py-1 bg-green-100 text-green-700 rounded shadow-lg">
                              Copied!
                            </div>
                          )}
                        </div>
                      )}

                      <ErrorMessage
                        name="videoLinks"
                        component="div"
                        className="error"
                      />

                      <Button
                        text={
                          currentItems?.introVideoLink
                            ? "Delete Video"
                            : "Upload Video"
                        }
                        type="button"
                        className="float-end"
                        onClick={() => {
                          setUploadVisible(
                            currentItems?.introVideoLink ? false : true
                          );
                          setStatusPublic(true);
                          currentItems?.introVideoLink &&
                            handleDeleteYTVideo(
                              "intro",
                              values,
                              setFieldValue,
                              0
                            );
                          // currentItems?._id
                          //   ? setIsUpdate({
                          //       introVideo: true,
                          //     })
                          //   : setIsUpdate({
                          //       introVideo: false,
                          //     });
                        }}
                      />
                    </div>

                    {/*Contact   */}
                    <div className="mt-2">
                      <FormField
                        label="Contact No"
                        tooltip="Enter expert's Contact number"
                      >
                        <TextInput
                          name="expertContact"
                          type="number"
                          placeholder="Enter Contact number"
                          value={values.expertContact}
                          className={"mb-4"}
                          onChange={handleChange}
                        />
                        <ErrorMessage
                          name="expertContact"
                          component="div"
                          className="error"
                        />
                      </FormField>
                    </div>

                    {/* courseDetails.courseLevel */}
                    <div className="mt-2">
                      <FormField
                        label="Course Level"
                        tooltip="Select Course Level"
                      >
                        <div id="courseLevel" className="mb-4 w-full">
                          <Dropdown
                            options={[
                              { label: "Beginner", value: "Beginner" },
                              { label: "Intermediate", value: "Intermediate" },
                              { label: "Advanced", value: "Advanced" },
                            ]}
                            name="courseLevel"
                            value={values?.courseLevel}
                            className={"mb-4 w-full border h-10"}
                            onChange={handleChange}
                            handleOnchange={(v) => {
                              console.log("Selected course Level:", v);
                            }}
                          />
                          <ErrorMessage
                            name="courseLevel"
                            component="div"
                            className="error"
                          />
                        </div>
                      </FormField>
                    </div>

                    {/* syllabus list  */}
                    <div className="mt-2">
                      {/* Header with Syllabus and Add Button */}
                      <div className="flex justify-between items-center mb-2">
                        <div className="flex items-center">
                          <label className="block text-sm mr-2">Syllabus</label>
                          <Tooltip text="Add lessons to the syllabus with title, duration and video link." />
                        </div>
                        <FieldArray
                          name="syllabusDetails.syllabus"
                          render={(arrayHelpers) => (
                            <button
                              type="button"
                              className="flex items-center gap-2 px-4 py-2 rounded-md bg-blue-100 hover:bg-blue-200"
                              onClick={() =>
                                arrayHelpers.push({
                                  title: "",
                                  duration: "",
                                  video: "",
                                  downloadableMaterials: [],
                                })
                              }
                            >
                              <IoAddCircleOutline className="text-xl text-blue-500" />
                              <span className="text-sm text-blue-500">
                                Add Lesson
                              </span>
                            </button>
                          )}
                        />
                      </div>

                      {/* Lessons List */}
                      <FieldArray
                        name="syllabusDetails.syllabus"
                        render={(arrayHelpers) => (
                          <div>
                            {values.syllabusDetails.syllabus?.length > 0 &&
                              values.syllabusDetails.syllabus.map(
                                (lesson, index) => (
                                  <div
                                    key={index}
                                    className="mb-4 border p-3 rounded-md bg-gray-50 flex flex-col gap-4"
                                  >
                                    {/* Lesson Title and Duration */}
                                    <div className="flex gap-4">
                                      <TextInput
                                        name={`syllabusDetails.syllabus[${index}].title`}
                                        placeholder="Lesson Title"
                                        value={lesson.title}
                                        onChange={(e) =>
                                          setFieldValue(
                                            `syllabusDetails.syllabus[${index}].title`,
                                            e.target.value
                                          )
                                        }
                                      />
                                      <TextInput
                                        name={`syllabusDetails.syllabus[${index}].duration`}
                                        placeholder="Lesson Duration (e.g., 10 min)"
                                        value={lesson.duration}
                                        onChange={(e) =>
                                          setFieldValue(
                                            `syllabusDetails.syllabus[${index}].duration`,
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>

                                    {/* Video Upload */}
                                    <TextInput
                                      name={`syllabusDetails.syllabus[${index}].video`}
                                      placeholder="Enter the below link"
                                      // value={ytUrl.syllabus && ytUrl.syllabus}
                                      required={true}
                                      value={lesson.video}
                                      readOnly={
                                        ytUrl.syllabus[index] ? false : true
                                      }
                                      onChange={(e) =>
                                        setFieldValue(
                                          `syllabusDetails.syllabus[${index}].video`,
                                          e.target.value
                                        )
                                      }
                                    />

                                    <div className="flex items-center justify-between ">
                                      <Button
                                        text={
                                          currentItems?.syllabusDetails
                                            ?.syllabus?.[index]?.video
                                            ? "Delete Video"
                                            : "Upload Video"
                                        }
                                        type="button"
                                        className="float-end"
                                        onClick={() => {
                                          setUploadVisible(
                                            currentItems?.syllabusDetails
                                              ?.syllabus?.[index]?.video
                                              ? false
                                              : true
                                          );
                                          setIndex(index);
                                          currentItems?.syllabusDetails
                                            ?.syllabus?.[index]?.video &&
                                            handleDeleteYTVideo(
                                              "course",
                                              values,
                                              setFieldValue,
                                              index
                                            );
                                          // setCurrentItems();
                                          // currentItems?.syllabusDetails?.syllabus?.[0]
                                          //   ?.video
                                          //   ? setIsUpdate({
                                          //       courseVideo: true,
                                          //     })
                                          //   : setIsUpdate({
                                          //       courseVideo: false,
                                          //     });
                                        }}
                                      />

                                      {/* <div className="flex items-center space-x-3">
                                        <p className="text-gray-700 font-semibold">
                                          {" "}
                                         
                                          {isPrivate ? "Private" : "Public"}
                                        </p>
                                        <button
                                          className={`relative inline-flex h-6 w-12 rounded-full border-2 transition-all ${
                                            isPrivate
                                              ? "bg-green-500 border-green-500"
                                              : "bg-gray-300 border-gray-300"
                                          }`}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setIsPrivate(!isPrivate);
                                          }}
                                        >
                                          <span
                                            className={`absolute h-5 w-5 bg-white rounded-full shadow-md transform transition-transform ${
                                              isPrivate
                                                ? "translate-x-6"
                                                : "translate-x-0"
                                            }`}
                                          ></span>
                                        </button>
                                      </div> */}
                                    </div>

                                    {ytUrl.syllabus[index] && (
                                      <div className="relative group">
                                        <div
                                          onClick={() =>
                                            handleCopy(ytUrl.syllabus[index])
                                          }
                                          className="cursor-pointer w-40 text-blue-500 underline mb-2 hover:text-blue-600 transition duration-200"
                                        >
                                          {ytUrl.syllabus[index]}
                                        </div>
                                        {copied && (
                                          <div className="absolute top-0 left-10 ml-2 px-2 py-1 bg-green-100 text-green-700 rounded shadow-lg">
                                            Copied!
                                          </div>
                                        )}
                                      </div>
                                    )}

                                    {/* Downloadable Materials Upload */}
                                    <FieldArray
                                      name={`syllabusDetails.syllabus[${index}].downloadableMaterials`}
                                      render={(materialsHelpers) => (
                                        <div>
                                          <div className="flex justify-between items-center mb-2">
                                            <label className="block text-sm">
                                              Downloadable Materials
                                            </label>
                                            <button
                                              type="button"
                                              className="text-blue-500 text-sm"
                                              onClick={() =>
                                                materialsHelpers.push({
                                                  file: null,
                                                })
                                              }
                                            >
                                              Add Material
                                            </button>
                                          </div>
                                          {lesson.downloadableMaterials
                                            ?.length > 0 &&
                                            lesson.downloadableMaterials.map(
                                              (material, materialIndex) => (
                                                <div
                                                  key={materialIndex}
                                                  className="flex gap-4 items-center"
                                                >
                                                  <input
                                                    type="file"
                                                    name={`syllabusDetails.syllabus[${index}].downloadableMaterials[${materialIndex}].file`}
                                                    className="file-input"
                                                    onChange={(e) =>
                                                      setFieldValue(
                                                        `syllabusDetails.syllabus[${index}].downloadableMaterials[${materialIndex}].file`,
                                                        e.target.files[0]
                                                      )
                                                    }
                                                  />
                                                  <button
                                                    type="button"
                                                    className="text-red-600 text-sm"
                                                    onClick={() =>
                                                      materialsHelpers.remove(
                                                        materialIndex
                                                      )
                                                    }
                                                  >
                                                    Remove
                                                  </button>
                                                </div>
                                              )
                                            )}
                                        </div>
                                      )}
                                    />

                                    {/* Remove Lesson Button */}
                                    <button
                                      type="button"
                                      className="text-red-600 mt-2"
                                      onClick={() => arrayHelpers.remove(index)}
                                    >
                                      Remove Lesson
                                    </button>
                                  </div>
                                )
                              )}

                            {/* Error Message */}
                            <ErrorMessage
                              name="syllabusDetails.syllabus"
                              component="div"
                              className="error"
                            />
                          </div>
                        )}
                      />
                    </div>

                    {/* certification  */}
                    <div>
                      <ToggleField
                        text={"are you provide certification ?"}
                        name="certification"
                        value={values.certification}
                        toggaleHandleChange={(e) => {
                          const copySyllabusDetails = {
                            ...values.syllabusDetails,
                          };
                          copySyllabusDetails.certification = e.target.value;
                          setFieldValue("syllabusDetails", copySyllabusDetails);
                        }}
                      />
                      <ErrorMessage
                        name="certification"
                        component="p"
                        className="error"
                      />
                    </div>
                  </SidebarField>
                </Form>
              )}
            </Formik>
          )}

          {isUploadVisible && (
            <YouTubeUploader
              setUploadVisible={setUploadVisible}
              setYturl={setYturl}
              setStatusPublic={setStatusPublic}
              statusPublic={statusPublic}
              isUpdate={isUpdate}
              videoIds={videoIds}
              index={index}
            />
          )}
          {deleteModal && (
            <DeleteFieldModal
              isOpen={deleteModal}
              onClose={handleDeleteClose}
              onDelete={handleDelete}
            />
          )}
        </div>
      )}
    </>
  );
};

export default Resources;
